import {http} from '@/helpers/http-helper';

class Query {
    constructor(
        uuid,
        number,
        createdBy,
        date,
        headquarters,
        category,
        client,
        origin,
        adviser,
        description,
        nif,
        email,
        comment,
        urgent,
        potentialMember,
        canModifyPotentialMember,
        status,
        associatedProjects,
        answer,
        saveAnswerType,
        originQuery,
        issuesCount
    ) {
        this.uuid = uuid;
        this.number = number;
        this.createdBy = createdBy;
        this.date = date;
        this.headquarters = headquarters;
        this.category = category;
        this.client = client;
        this.origin = origin;
        this.adviser = adviser;
        this.description = description;
        this.nif = nif;
        this.email = email;
        this.comment = comment;
        this.urgent = urgent;
        this.potentialMember = potentialMember;
        this.canModifyPotentialMember = canModifyPotentialMember;
        this.status = status;
        this.associatedProjects = associatedProjects;
        this.answer = answer;
        this.saveAnswerType = saveAnswerType;
        this.originQuery = originQuery;
        this.issuesCount = issuesCount
    }
}

class QueryIssue {
    constructor(
        uuid,
        user,
        type,
        description,
        createdAt,
        updatedAt,
        deleted
    ) {
        this.uuid = uuid;
        this.user = user;
        this.type = type;
        this.description = description;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.deleted = deleted;
    }
}

export const getQueries = (searchData) => {
    return new Promise((resolve, reject) => {
        let queryString = Object.keys(searchData).map(key => key + '=' + searchData[key]).join('&');
        const url = 'queries?' + queryString;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let queries = [];

                    response.data.queries.forEach((query) => {
                        queries.push(
                            new Query(
                                query.uuid,
                                query.number,
                                query.createdBy,
                                new Date(query.date),
                                query.headquarters,
                                query.category,
                                query.client,
                                query.origin,
                                query.adviser,
                                query.description,
                                query.nif,
                                query.email,
                                query.comment,
                                query.urgent,
                                query.potentialMember,
                                query.canModifyPotentialMember,
                                query.status,
                                query.associatedProjects,
                                query.response,
                                query.saveAnswerType,
                                query.originQuery,
                                query.issuesCount,
                                query.memberName
                            ));
                    });

                    resolve({
                        queries: queries,
                        count: response.data.count
                    });

                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQuery = (queryId) => {
    return new Promise((resolve, reject) => {
        const url = 'queries/' + queryId;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    resolve(new Query(
                        response.data.uuid,
                        response.data.number,
                        response.data.createdBy,
                        new Date(response.data.date),
                        response.data.headquarters,
                        response.data.category,
                        response.data.client,
                        response.data.origin,
                        response.data.adviser,
                        response.data.description,
                        response.data.nif,
                        response.data.email,
                        response.data.comment,
                        response.data.urgent,
                        response.data.potentialMember,
                        response.data.canModifyPotentialMember,
                        response.data.status,
                        response.data.associatedProjects,
                        response.data.response,
                        response.data.saveAnswerType,
                        response.data.originQuery,
                        response.data.issuesCount
                    ));

                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createQuery = (
    advisers,
    headquartersId,
    clientId,
    urgent,
    potentialMember,
    description,
    comment,
    origin,
    date,
    associatedProjects,
    originQueryId,
    status
) => {
    return new Promise((resolve, reject) => {
        const url = 'queries';
        http.post(url, {
            advisers,
            headquartersId,
            clientId,
            urgent,
            potentialMember,
            description,
            comment,
            origin,
            date,
            associatedProjects,
            originQueryId,
            status
        })
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateQuery = (
    queryId,
    advisers,
    date,
    headquartersId,
    origin,
    description,
    comment,
    urgent,
    potentialMember,
    status,
    associatedProjects
) => {
    return new Promise((resolve, reject) => {
        const url = 'queries/' + queryId;
        http.post(url, {
            advisers,
            date,
            headquartersId,
            origin,
            description,
            comment,
            urgent,
            potentialMember,
            status,
            associatedProjects
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const reScheduleQuery = (
    queryId,
    date,
    message,
) => {
    return new Promise((resolve, reject) => {
        const url = 'queries/' + queryId + '/re-schedule';
        http.post(url, {
            date,
            message
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQueryIssues = (queryId) => {
    return new Promise((resolve, reject) => {
        const url = 'queries/' + queryId + '/issues';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let issues = [];

                    response.data.forEach((queryIssue) => {
                        issues.push(
                            new QueryIssue(
                                queryIssue.uuid,
                                queryIssue.user,
                                queryIssue.type,
                                queryIssue.description,
                                new Date(queryIssue.createdAt),
                                new Date(queryIssue.updatedAt),
                                queryIssue.deleted
                            ));
                    });

                    resolve(issues);

                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const addQueryIssue = (queryId, issueTypeId, description, sendToQueryDepartment) => {
    return new Promise((resolve, reject) => {
        const url = 'queries/' + queryId + '/issues';
        const data = {
            queryIssueTypeId: issueTypeId,
            description: description,
            sendToQueryDepartment: sendToQueryDepartment
        };
        http.post(url, data)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const saveAnswerQuery = (queryId, status, answer, saveAnswerType, sendToCommercial) => {
    return new Promise((resolve, reject) => {
        const url = 'queries/' + queryId + '/answer';
        const data = {
            status: status,
            answer: answer,
            saveAnswerType: saveAnswerType,
            sendToCommercial: sendToCommercial
        };
        http.post(url, data)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQueryActivitiesReport = (adviserId, date) => {
    return new Promise((resolve, reject) => {
        const url = 'queries/report/' + adviserId + '?date=' + date;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let queriesActivities = [];

                    response.data.forEach((data) => {
                        let query = data.query;
                        queriesActivities.push(
                            {
                                query: new Query(
                                    query.uuid,
                                    query.number,
                                    query.createdBy,
                                    new Date(query.date),
                                    query.headquarters,
                                    query.category,
                                    query.client,
                                    query.origin,
                                    query.adviser,
                                    query.description,
                                    query.comment,
                                    query.urgent,
                                    query.potentialMember,
                                    query.canModifyPotentialMember,
                                    query.status,
                                    query.associatedProjects,
                                    query.response,
                                    query.saveAnswerType,
                                    query.originQuery,
                                    query.issuesCount
                                ),
                                activities: data.activities
                            });
                    });

                    resolve(queriesActivities);

                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
